import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import { vuetify } from "./plugins/vuetify";
import VueLogger from "vuejs3-logger";
import { options } from "@/plugins/vuejs-logger";
import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  // err: Error trace
  // instance: The component in which error occurred
  // info: Vue-specific error information (lifecycle hooks, events, etc.)

  let actionType = "Global error";
  let actionValue = instance?.$options?.name || instance?.$options?._componentTag || "Unknown Component";
  let actionData = {
    info: `Error: ${err.toString()}\nInfo: ${info}`,
  };

  if (store && store.dispatch) {
    store.dispatch("dataLog/setData", {
      actionType,
      actionValue,
      actionData,
    });
  } else {
    console.error("Store or dispatch method is not available.");
  }
};

app.use(router);
app.use(store);
app.use(vuetify);
app.use(LoadingPlugin);
app.use(VueLogger, options);

app.mount("#app");

export default app;
